/*eslint no-useless-escape: "off"*/

export function linkifyText(text: string) {
  const protocolPattern =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&//=]*)/gim;

  const wwwPattern =
    /(^|[^\/])www\.(([a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.)+([a-zA-Z]{2,}))(:\\d+)?(\/[-a-zA-Z0-9@:%._\\+~#=]*)*/gim;

  const emailPattern = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)(?![^<]*<\/a>)/gim;

  let result = text.replace(
    protocolPattern,
    (match) => `<a href="${match}" target="_blank" rel="noreferrer">${match}</a>`
  );

  result = result.replace(wwwPattern, (match, p1, p2) => {
    let extra_character = '';
    if (match.substring(1, 5) === 'www.') {
      extra_character = match[0];
      match = match.substring(1);
    }

    return `${extra_character}<a href="https:\/\/${p2}" target="_blank" rel="noreferrer">${p2}</a>`;
  });

  result = result.replace(
    emailPattern,
    (match, p1) => `<a href="mailto:${p1}" target="_blank" rel="noreferrer">${p1}</a>`
  );

  return result;
}
